import { render, staticRenderFns } from "./service-chip.vue?vue&type=template&id=385eb46e"
import script from "./service-chip.vue?vue&type=script&lang=js"
export * from "./service-chip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports